import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { LcsDateTimePickerContentComponent } from './date-time-picker-content/date-time-picker-content.component';
import { LcsDateTimePickerInputDirective } from './date-time-picker-input/date-time-picker-input.directive';
import { LcsDateTimePickerToggleComponent } from './date-time-picker-toggle/date-time-picker-toggle.component';
import {
   LCS_DATE_TIME_PICKER_SCROLL_STRATEGY_FACTORY_PROVIDER,
   LcsDateTimePickerComponent,
} from './date-time-picker/date-time-picker.component';

import { MatButtonModule } from '@angular/material/button';
import { LcsNativeDateTimeModule } from './configuration/native-date-time.module';
import { SegmentedTimepickerComponent } from './segmented-time-picker/segmented-timepicker.component';
import { LcsSpinButtonModule } from './spin-button.module';
import { LcsTimePickerComponent } from './time-picker/time-picker.component';
@NgModule({
   declarations: [
      LcsDateTimePickerToggleComponent,
      LcsDateTimePickerComponent,
      LcsDateTimePickerContentComponent,
      LcsDateTimePickerInputDirective,
      LcsTimePickerComponent,
      SegmentedTimepickerComponent,
   ],
   exports: [
      LcsDateTimePickerComponent,
      LcsDateTimePickerInputDirective,
      LcsDateTimePickerToggleComponent,
      LcsTimePickerComponent,
      SegmentedTimepickerComponent,
   ],
   imports: [
      CommonModule,
      LcsSpinButtonModule,
      MatButtonModule,
      MatDatepickerModule,
      LcsNativeDateTimeModule,
      MatDividerModule,
      MatIconModule,
      ReactiveFormsModule,
   ],
   providers: [LCS_DATE_TIME_PICKER_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class LcsDateTimePickerModule {}
